/* ============================================================
   KEPT — mobile menu
   Escape and the close button both dismiss the drawer, and the
   page behind is locked so it cannot scroll underneath.
   ============================================================ */
(function () {
  'use strict';
  if (window.__keptMenuInit) return;
  window.__keptMenuInit = true;

  function init() {
    var toggle = document.querySelector('[data-kept-menu-toggle]');
    if (!toggle) return;
    var drawer = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!drawer) return;

    function close() {
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('kept-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      window.setTimeout(function () {
        if (toggle.getAttribute('aria-expanded') === 'false') drawer.hidden = true;
      }, 300);
      toggle.focus();
    }

    function open() {
      drawer.hidden = false;
      /* Next frame, so the transition has a closed state to move from. */
      window.requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.documentElement.classList.add('kept-menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }

    toggle.addEventListener('click', function () {
      if (toggle.getAttribute('aria-expanded') === 'true') { close(); } else { open(); }
    });

    [].forEach.call(drawer.querySelectorAll('[data-kept-menu-close]'), function (btn) {
      btn.addEventListener('click', close);
    });

    /* Any link inside the drawer closes it, otherwise an anchor jump leaves
       the panel covering the thing it just scrolled to. */
    [].forEach.call(drawer.querySelectorAll('a'), function (link) {
      link.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') close();
    });

    /* Rotating a phone to landscape can cross the desktop breakpoint, which
       would leave the page locked with an invisible drawer open. */
    window.addEventListener('resize', function () {
      if (window.innerWidth > 900 && toggle.getAttribute('aria-expanded') === 'true') close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
